import { BranchQrisMerchantCreatePage } from "@/features/branch-qris-merchant/pages/BranchQrisMerchantCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/branch-qris-merchant/create")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["branch_qris_merchants.create"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: BranchQrisMerchantCreatePage,
});
